import { render, staticRenderFns } from "./CustomFileInput.vue?vue&type=template&id=85215422&"
import script from "./CustomFileInput.vue?vue&type=script&lang=js&"
export * from "./CustomFileInput.vue?vue&type=script&lang=js&"
import style0 from "./CustomFileInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib'
installComponents(component, {VTextField})
